import { registerComponent } from '../app'
import { SELECT_SS_CATEGORY, DESELECT_SS_CATEGORY, USER_SCROLL, WINDOW_RESIZE } from '../events'

const SSCategory = (scope, el) => {
	const props = {
		activeClass: 'active',
		category: el.getAttribute('data-component-ss-category'),
		noDeselect: el.hasAttribute('data-no-deselect')
	}

	const state = {
		activeCategory: null
	}

	el.addEventListener('click', e => {
		e.preventDefault()

		// Hack to fix scroll issue

		setTimeout(() => {
			scope.emit(USER_SCROLL)
		}, 500)

		setTimeout(() => {
			scope.emit(WINDOW_RESIZE)
		}, 100)

		if (el.classList.contains(props.activeClass) && !props.noDeselect) {
			scope.emit(DESELECT_SS_CATEGORY, props.category)
			return
		}

		scope.emit(SELECT_SS_CATEGORY, props.category)
	})

	scope.on(
		DESELECT_SS_CATEGORY,
		category =>
			(!category || category == props.category) && el.classList.remove(props.activeClass)
	)

	scope.on(SELECT_SS_CATEGORY, category =>
		category == props.category
			? el.classList.add(props.activeClass)
			: props.noDeselect
			? el.classList.remove(props.activeClass)
			: null
	)
}

registerComponent('ss-category', SSCategory)
